import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AdminEnquiries from "./pages/AdminEnquiries";
import Lenis from "lenis";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/site/Navbar";
import Hero from "./components/site/Hero";
import Marquee from "./components/site/Marquee";
import Film from "./components/site/Film";
import MoreThanDecor from "./components/site/MoreThanDecor";
import WhatIs from "./components/site/WhatIs";
import Chakras from "./components/site/Chakras";
import EverydaySpaces from "./components/site/EverydaySpaces";
import Craftsmanship from "./components/site/Craftsmanship";
import Details from "./components/site/Details";
import Editorial from "./components/site/Editorial";
import Story from "./components/site/Story";
import Enquiry from "./components/site/Enquiry";
import Footer from "./components/site/Footer";
import WhatsAppButton from "./components/site/WhatsAppButton";

function Site() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const id = anchor.getAttribute("href");
      if (id.length > 1 && document.querySelector(id)) {
        e.preventDefault();
        lenis.scrollTo(id, { offset: -72, duration: 1.4 });
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(rafId);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#FDFBF7] text-[#1A201C]" data-testid="app-root">
      <div className="grain-overlay" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Film />
        <MoreThanDecor />
        <WhatIs />
        <Chakras />
        <EverydaySpaces />
        <Craftsmanship />
        <Details />
        <Editorial />
        <Story />
        <Enquiry />
      </main>
      <Footer />
      <WhatsAppButton />
      <Toaster position="bottom-center" />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin/enquiries" element={<><AdminEnquiries /><Toaster position="bottom-center" /></>} />
        <Route path="*" element={<Site />} />
      </Routes>
    </BrowserRouter>
  );
}
